module.exports = __webpack_public_path__ + "d2195f116eb54bba1ad2822971a3be9c.MP3";